import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class NotLoggedInError extends CodedError {
  static get errorName() {
    return errorCodes.notLoggedIn.code;
  }

  constructor(message: string = errorCodes.notLoggedIn.message) {
    super(message);
    this.code = errorCodes.notLoggedIn.code;
    this.message = `${message} ${errorCodes.notLoggedIn.code}`;
    this.name = errorCodes.notLoggedIn.name;
    this.status = errorCodes.notLoggedIn.status;
  }
}
